import { DatePicker } from 'src/components/date-picker';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { FundingService } from 'src/services/funding.service';
import { IUser } from 'src/utils/interfaces/user';
import Spinner from 'src/components/ui/spinner';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import {
    EftContent,
    financialServicesText,
} from 'src/components/eftNotifications/EftContent';
import {
    IEFTNotifications,
    RemittanceInfo,
} from 'src/services/models/funding.service';
import React, { useEffect, useState } from 'react';
import './styles.scss';

const loader = (
    <div className='loader_container'>
        <Spinner />
    </div>
);

const EftNoResponse = () => {
    const { eft } = useLocalization();
    return (
        <div className='eft-no-content'>
            <div className='inner-content'>
                <span className='header'>{eft.EFT_NO_RESPONSE}</span>
                <span>{eft.EFT_SELECT_OTHER}</span>
            </div>
        </div>
    );
};

const Application: React.FC<{}> = () => {
    const defaultIndex = 0;
    const [eftResponse, setEftResponse] = useState<IEFTNotifications[]>();
    const [tableContent, setTableContent] = useState<RemittanceInfo[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [contentIndex, setContentIndex] = useState<number>(defaultIndex);

    const { eft } = useLocalization();
    const service = new FundingService();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });

    useEffect(() => {
        !!eftResponse &&
            setTableContent(eftResponse[contentIndex].RemittanceInformation);
    }, [contentIndex]);

    const getEFTNotifications = async (startDate: string, endDate: string) => {
        console.log('getEFTNotifications', startDate, endDate);
        const dealerId = dealerDataInfo?.dealer.dealerNumber;
        const ccNumber = dealerDataInfo?.dealer.ccNumbers[0].toString();
        setLoading(true);
        if (!!dealerId && !!ccNumber) {
            try {
                const res = await service.fundingEFT(
                    dealerId,
                    ccNumber,
                    startDate,
                    endDate,
                );
                if (!!res && !!res.data) {
                    setEftResponse(
                        res.data.sort(
                            (a, b) =>
                                new Date(a.OperationDate).getTime() -
                                new Date(b.OperationDate).getTime(),
                        ),
                    );
                    setTableContent(
                        res.data[contentIndex].RemittanceInformation,
                    );
                }
                setLoading(false);
            } catch {
                setTableContent([]);
                setEftResponse([]);
                setLoading(false);
            }
        }
    };

    const today = new Date();

    const minimumDate = new Date(today);
    minimumDate.setFullYear(minimumDate.getFullYear() - Number('1'));

    const maximumDate = new Date(today);
    maximumDate.setDate(maximumDate.getDate() + Number('1'));

    return (
        <div className={'eft-wrapper-container'}>
            <div className='eft-wrapper'>
                <div className='eft-header'>
                    <div className='eft-header-text'>
                        {eft.LABEL_EFT_HEADER}
                    </div>
                </div>
                <div className='date-picker-container'>
                    <DatePicker
                        handleOnClose={getEFTNotifications}
                        minDate={minimumDate}
                        maxDate={maximumDate}
                        defaultToToday={false}
                    />
                </div>
                {!loading ? (
                    !!eftResponse && !!eftResponse.length ? (
                        <>
                            <EftContent
                                tableContent={tableContent}
                                setContentIndex={setContentIndex}
                                dealerDataInfo={dealerDataInfo}
                                eftResponse={eftResponse}
                                contentIndex={contentIndex}
                            />
                            <div className='disclaimer-container'>
                                <div className='disclaimer'>
                                    <span className='bold'>Note:</span>
                                    {` ${eft.EFT_DISCLAIMER_FUNDS}`}
                                </div>
                                <div className='disclaimer'>{`${
                                    eft.EFT_THANKS
                                } ${financialServicesText(
                                    dealerDataInfo?.dealer.brand,
                                    eft,
                                )}.`}</div>
                                <div className='disclaimer'>
                                    {eft.EFT_DISCLAIMER_CONFIDENTIAL}
                                </div>
                            </div>
                        </>
                    ) : (
                        <EftNoResponse />
                    )
                ) : (
                    loader
                )}
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
            </div>
        </div>
    );
};

export default Application;
